import './Separator.scss';

const Separator = () => <hr className="section-separator" />;

export default Separator;
